
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le parti agrarien a subi la plus grande perte d'électeurs avec un recul de 3,6% des voix. En nombre d'électeurs, il a obtenu le pire résultat depuis 1999, ce que l'on peut également constater sur la carte: les pertes dominent, et les gains de voix sont très légers dans certaines communes. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;